'use strict';

angular.module('buyers')
.directive("dropdown", ['$rootScope', function($rootScope) {
  return {
    restrict : "AE",
    templateUrl : "partials/listing-select.html",
    link : function($scope, $el, $attrs) {

      $scope.options = $rootScope.currentUser.listings;
      $scope.selected = $rootScope.currentListing.propertyRef;

      var dd = $el[0].firstChild;

      angular.element('menu > .item.option').each(function() {
        if (angular.element(this).attr('data-value') == $scope.selected) {
          angular.element(this).addClass('selected');
          angular.element('input[name=active]').val($scope.selected);
          angular.element('div.text').empty().text($rootScope.currentListing.address);
        }
      });

      $scope.selected = function(opt) {
        $rootScope.currentListing = opt;
      }

      angular.element('.ui.dropdown').dropdown();

    }
  };
}]);
